<template>
  <section class="sidebar">
    <section class="fullScreen" id="sidebar">
      <!-- ============================== Big Screen Sidebar -->
      <v-navigation-drawer
        class="main_sidebar"
        :class="mainNavOpen ? 'active' : ''"
        permanent
        :expand-on-hover="false"
        ref="mainSidebar"
      >
        <!-- Upper Scection -->
        <div class="top_logo">
          <!-- change sidebar -->
          <span @click.stop="toggleMainMenu" class="toggleMainMenue">
            <i class="fa fa-bars"></i>
          </span>
          <!-- change sidebar -->
          <div class="logo">
            <h2>{{ $t("dashName") }}</h2>
          </div>
          <!-- <div class="toggleResize">
          <button
            @click="toggleSideBarFullWidth"
            class="btn ful-w"
            :class="{ ful_back: menueMinWidth }"
          ></button>
        </div> -->
        </div>

        <!-- <v-divider></v-divider> -->

        <v-list>
          <template>
            <v-list-item
              to="/profile/edit"
              class="p-2 porfile-rap"
              v-if="userDataExist"
            >
              <div class="d-flex align-items-center gap-3" v-if="userDataExist">
                <div
                  class="img-raper rounded-circle d-flex align-items-center justify-content-center"
                  style="width: 50px; height: 50px; overflow: hidden"
                >
                  <img
                    :src="userDataExist.avater"
                    style="width: 100%; height: 100%"
                  />

                  <!-- <img
                    class=""
                    style="/* object-fit: cover; */ width: 100%; height: 100%"
                    v-if="current_theme == 'light'"
                    src="@/assets/media/images/logo/logo.png"
                  />
                  <img
                    width="100"
                    class="img-fluid"
                    v-else
                    src="@/assets/media/images/logo/light_logo.png"
                  /> -->
                </div>
                <div class="text">
                  <h3 class="name">{{ userDataExist.full_name }}</h3>
                  <p class="available">{{ $t("labels.online") }}</p>
                </div>
              </div>
            </v-list-item>
            <v-list-item to="/">
              <v-icon>fas fa-home</v-icon>
              <v-list-item-title>{{ $t("navs.home") }}</v-list-item-title>
            </v-list-item>
          </template>
          <template v-for="item in sidebar">
            <div
              class="divider_new"
              v-if="item.label && item.categories.length"
              :key="item.id"
            >
              <span>{{ item.label }}</span>
            </div>

            <template v-for="sub_item in item.categories">
              <v-list-item
                v-if="
                  sub_item.key == 'general' &&
                  !$permission.allowed(`${sub_item.permissions[0].url}`)
                "
                :key="sub_item.id"
                :to="`/${sub_item.permissions[0].url}`"
              >
                <v-icon>{{ sub_item.icon }}</v-icon>
                <v-list-item-title>{{ sub_item.title }} </v-list-item-title>
              </v-list-item>
              <!-- If DropDown -->
              <v-list-group
                :key="sub_item.uuid"
                v-else-if="
                  !$permission.allowed(`${sub_item.permissions[0].url}`) ||
                  !$permission.allowed(`${sub_item.permissions[1]?.url}`)
                "
                :class="{
                  activeDropDown: sub_item.active,
                }"
                class="parnet"
                v-model="sub_item.active"
                :prepend-icon="sub_item.icon"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <div v-for="child in sub_item.permissions" :key="child.id">
                  <v-list-item
                    :to="`/${child.url}`"
                    v-if="!$permission.allowed(`${child.url}`)"
                  >
                    <v-list-item-content>
                      <!-- <span class="polit"></span> -->
                      <v-list-item-title>{{ child.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-group>
            </template>
          </template>
        </v-list>
      </v-navigation-drawer>
      <!-- ============================== Small Screen Sidebar -->
    </section>
    <aside class="smallScreenSidebar main_sidebar" ref="smallSidebar">
      <span @click.stop="toggleMenu" class="close">
        <i class="fas fa-times"></i>
      </span>

      <!-- Upper Scection -->
      <div class="top_logo">
        <div class="logo">
          <router-link to="/">
            <div style="width: 50px; height: 50px">
              <img
                class="img-fluid"
                style="width: 100%"
                v-if="current_theme == 'light'"
                src="@/assets/media/images/logo/light_logo.svg"
              />
              <img
                style="width: 100%"
                class="img-fluid"
                v-else
                src="@/assets/media/images/logo/logo.png"
              />
            </div>
          </router-link>
        </div>
      </div>
      <v-list>
        <v-list-item class="p-2 porfile-rap bg-light">
          <div class="d-flex align-items-center gap-3">
            <div
              class="img-raper rounded-circle d-flex align-items-center justify-content-center"
              style="width: 50px; height: 50px; overflow: hidden"
            >
              <img
                :src="userDataExist.avater"
                style="width: 100%; height: 100%"
              />

              <!-- <img
                class=""
                style="/* object-fit: cover; */ width: 100%; height: 100%"
                v-if="current_theme == 'light'"
                src="@/assets/media/images/logo/logo.png"
              />
              <img
                width="100"
                class="img-fluid"
                v-else
                src="@/assets/media/images/logo/light_logo.png"
              /> -->
            </div>
            <div class="text">
              <h3 class="name">{{ userDataExist.full_name }}</h3>
              <p class="available">{{ $t("labels.online") }}</p>
            </div>
          </div>
        </v-list-item>
        <v-list-item to="/">
          <v-icon>fas fa-home</v-icon>
          <v-list-item-title>{{ $t("navs.home") }}</v-list-item-title>
        </v-list-item>

        <template v-for="item in sidebar">
          <div class="divider_new" v-if="item.label" :key="item.id">
            <span>{{ item.label }}</span>
          </div>
          <template v-for="sub_item in item.categories">
            <v-list-item
              v-if="
                sub_item.key == 'general' &&
                !$permission.allowed(`${sub_item.permissions[0].url}`)
              "
              :key="sub_item.id"
              :to="`/${sub_item.permissions[0].url}`"
            >
              <v-icon>{{ sub_item.icon }}</v-icon>
              <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
            </v-list-item>
            <!-- If DropDown -->
            <v-list-group
              v-else-if="
                !$permission.allowed(`${sub_item.permissions[0].url}`) ||
                !$permission.allowed(`${sub_item.permissions[1]?.url}`)
              "
              :key="sub_item.uuid"
              :class="{
                activeDropDown: sub_item.active,
              }"
              class="parnet"
              v-model="sub_item.active"
              :prepend-icon="sub_item.icon"
              @click.stop
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-for="child in sub_item.permissions" :key="child.id">
                <v-list-item
                  v-if="!$permission.allowed(`${child.url}`)"
                  :to="`/${child.url}`"
                >
                  <v-list-item-content>
                    <!-- <span class="polit"></span> -->
                    <v-list-item-title>{{ child.title }}</v-list-item-title>
                    <!-- <v-list-item-title>ZOSAR</v-list-item-title> -->
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list-group>
          </template>
        </template>
      </v-list>
      <ul class="navIcons" v-if="false">
        <!-- Theme -->
        <li v-if="current_theme == 'dark'" @click="changeTheme('light')">
          <i class="fal fa-sun"></i>
        </li>
        <li v-if="current_theme == 'light'" @click="changeTheme('dark')">
          <i class="fal fa-moon"></i>
        </li>

        <!-- Lang -->
        <li v-if="lang == 'ar'" @click="changeLang('en')">
          <i class="fal fa-globe"></i>
        </li>
        <li v-if="lang == 'en'" @click="changeLang('ar')">
          <i class="fal fa-globe"></i>
        </li>
      </ul>
    </aside>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menueMinWidth: true,
      userDataExist: false,

      Originsidebar: [
        {
          label: "",
          icon: "fa-solid fa-layer-group",
          categories: [
            {
              icon: "fa-solid fa-image",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "slider/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "slider/add",
                },
              ],
              title: "الاسليدر",
            },
          ],
        },
        {
          label: "",
          icon: "fa-solid fa-layer-group",
          categories: [
            {
              icon: "fa-solid fa-layer-group",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "categories/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "categories/add",
                },
              ],
              title: "الأقسام الرئيسية",
            },
          ],
        },
        {
          label: "اعدادات المنتجات",
          icon: "fa fa-shopping-cart",
          categories: [
            {
              icon: "fa-solid fa-layer-group",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "sizes/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "sizes/add",
                },
              ],
              title: "المقاسات",
            },
            {
              icon: "fas fa-paint-brush",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "colors/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "colors/add",
                },
              ],
              title: "الألوان",
            },
            {
              icon: "fa-solid fa-star",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "feature/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "feature/add",
                },
              ],
              title: "الخصائص",
            },
          ],
        },
        {
          label: "المنتجات",
          icon: "fa fa-shopping-cart",
          categories: [
            {
              icon: "fa fa-shopping-cart",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "products/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "products/add",
                },
              ],
              title: "المنتجات",
            },
            {
              icon: "far fa-bolt",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "offer/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "offer/add",
                },
              ],
              title: "العروض",
            },
            {
              icon: "far fa-flag",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "coupon/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "coupon/add",
                },
              ],
              title: "برومو كود",
            },
            {
              icon: "far fa-bolt",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "flash-sale/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "flash-sale/add",
                },
              ],
              title: "الخصومات المفاجئة",
            },
          ],
        },
        {
          label: "الطلبات",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fas fa-question",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "order/show-all",
                },
              ],
              title: "الطلبات",
            },
          ],
        },
        {
          label: "",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "far fa-flag",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "return-orders/show-all",
                },
              ],
              title: "المرتجعات",
            },
          ],
        },
        {
          label: "",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fas fa-truck",
              permissions: [
                {
                  url: "stock-tracking/show-all",
                },
              ],
              title: "تتبع المخزون",
            },
          ],
        },
        {
          label: "",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fas fa-layer-group",
              permissions: [
                {
                  url: "reports/show-all",
                },
              ],
              title: "التقارير",
            },
          ],
        },
        {
          label: "",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fas fa-sack-dollar",
              permissions: [
                {
                  url: "withdrawal/show-all",
                },
              ],
              title: "طلبات السحب",
            },
          ],
        },
        {
          label: "",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fas fa-question",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "cart/show-all",
                },
              ],
              title: "السلات المتروكة",
            },
          ],
        },
        {
          label: "",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fa-solid fa-star",
              permissions: [
                {
                  url: "rates/show-all",
                },
              ],
              title: "التقييمات",
            },
          ],
        },
        {
          label: "اعدادات المستخدمين",
          icon: "",
          categories: [
            {
              icon: "fa-solid fa-users",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "client/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "client/add",
                },
              ],
              title: "المستخدمين",
            },
            {
              icon: "fa-solid fa-users",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "admins/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "admins/add",
                },
              ],
              title: "المديرين",
            },
            {
              icon: "fa-solid fa-users",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "role/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "role/add",
                },
              ],
              title: "الأدوار",
            },
          ],
        },
        {
          label: "اعدادات عامة",
          icon: "",
          categories: [
            {
              icon: "far fa-flag",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "countries/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "countries/add",
                },
              ],
              title: "الدول",
            },
            {
              icon: "far fa-building",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "cities/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "cities/add",
                },
              ],
              title: "المدن",
            },
            {
              icon: "fas fa-bell",
              permissions: [
                {
                  title: "عرض الكل",
                  url: "notifications/show-all",
                },
                {
                  title: "اضافة جديد",
                  url: "notifications/add",
                },
              ],
              title: "الاشعارات",
            },
          ],
        },

        {
          label: "اعدادات لوحه التحكم",
          icon: "",
          categories: [
            {
              key: "general",
              icon: "fas fa-question",
              permissions: [
                {
                  url: "commonQuestions/show-all",
                },
              ],
              title: "الاسئلة الشائعة",
            },
            {
              key: "general",
              icon: "fal fa-tools",
              permissions: [
                {
                  url: "about/show-all",
                },
              ],
              title: "من نحن",
            },
            {
              key: "general",
              icon: "fal fa-tools",
              permissions: [
                {
                  url: "term/show-all",
                },
              ],
              title: "الشروط والأحكام",
            },
            {
              key: "general",
              icon: "fal fa-tools",
              permissions: [
                {
                  url: "privacy/show-all",
                },
              ],
              title: "سياسة الخصوصية",
            },
            {
              key: "general",
              icon: "fal fa-envelope ",
              permissions: [
                {
                  url: "contacts/show-all",
                },
              ],
              title: "رسائل التواصل",
            },
            {
              key: "general",
              icon: "fal fa-user",
              permissions: [
                {
                  url: "news-letter/show-all",
                },
              ],
              title: "مشتركين النشرة البريدية",
            },
            {
              key: "general",
              icon: "fas fa-user-cog",
              permissions: [
                {
                  url: "settings",
                },
              ],
              title: "الاعدادات العامة",
            },
          ],
        },
      ],
      sidebar: [],
      mainNavOpen: true,
    };
  },

  methods: {
    toggleSideBarFullWidth() {
      this.menueMinWidth = !this.menueMinWidth;
      this.$store.dispatch("sideNav_module/onResize");
    },

    toggleMenu() {
      this.$refs.smallSidebar.classList.toggle("active");
    },

    toggleMainMenu() {
      this.mainNavOpen = !this.mainNavOpen;
      const mainNav = document.querySelector(".main_nav");
      mainNav.classList.toggle("active");
      const mainWrapper = document.querySelector(".app-wrapper");
      mainWrapper.classList.toggle("active");
    },

    changeTheme(value) {
      this.$store.dispatch("theme_module/changeTheme", value);
      if (value == "light") {
        this.$vuetify.theme.dark = false;
      } else {
        this.$vuetify.theme.dark = true;
      }
      this.$refs.smallSidebar.classList.remove("active");
    },

    changeLang(value) {
      this.$store.dispatch("lang_module/switchLang", value);
      this.$refs.smallSidebar.classList.remove("active");
    },
    manipulateTheSideBarComplete() {
      // Convert 'JSON' Object to JS Object
      const Json_Sidebar = JSON.parse(JSON.stringify(this.$t("sidebar")));
      Json_Sidebar.forEach((el) => {
        // IF Dropdown
        if (el.items) {
          // ======== Check Nested
          let inside_nested = false;
          el.items.forEach((element) => {
            if (element.items) {
              inside_nested = true;
            }
          });

          // ======== IF Nested Else
          if (inside_nested) {
            el.items.forEach((subEl) => {
              // Active
              subEl.activeRoutesMatch = subEl.items[0].url;

              // DropDown
              if (this.$route.path.includes(subEl.activeRoutesMatch)) {
                subEl.active = true;
              } else {
                subEl.active = false;
              }
            });
            el.activeRoutesMatch = el.parentUrl;

            // DropDown
            if (this.$route.path.includes(el.activeRoutesMatch)) {
              el.active = true;
            } else {
              el.active = false;
            }
          } else {
            el.activeRoutesMatch = el.items[0].url;

            // DropDown
            if (this.$route.path.includes(el.activeRoutesMatch)) {
              el.active = true;
            } else {
              el.active = false;
            }
          }
        }
      });
      this.sidebar = Json_Sidebar;
    },

    manipulateTheSideBar() {
      let Json_Sidebar = JSON.parse(JSON.stringify(this.$t("sidebar")));
      this.axios.get("get_my_permissions").then((res) => {
        localStorage.setItem(
          "outfit_dash_permissions",
          JSON.stringify(res.data.data)
        );
        // let currUserPermissions = [];
        // res.data.data.map((item) => {
        //   currUserPermissions.push(item.url);
        // });
        // let currentSidebar = [];
        // Json_Sidebar.map((item) => {
        //   item.categories.map((category) => {
        //     category.permissions.map((permission) => {
        //       if (currUserPermissions.includes(permission.url)) {
        //         if (!currentSidebar.find((el) => el.label == item.label)) {
        //           currentSidebar.push(item);
        //         }
        //       }
        //     });
        //   });
        // });
        // Json_Sidebar = currentSidebar;
        Json_Sidebar.forEach((el) => {
          // IF Dropdown
          if (el.items) {
            // ======== Check Nested
            let inside_nested = false;
            el.items.forEach((element) => {
              if (element.items) {
                inside_nested = true;
              }
            });

            // ======== IF Nested Else
            if (inside_nested) {
              el.items.forEach((subEl) => {
                // Active
                subEl.activeRoutesMatch = subEl.items[0].url;

                // DropDown
                if (this.$route.path.includes(subEl.activeRoutesMatch)) {
                  subEl.active = true;
                } else {
                  subEl.active = false;
                }
              });
              el.activeRoutesMatch = el.parentUrl;

              // DropDown
              if (this.$route.path.includes(el.activeRoutesMatch)) {
                el.active = true;
              } else {
                el.active = false;
              }
            } else {
              el.activeRoutesMatch = el.items[0].url;

              // DropDown
              if (this.$route.path.includes(el.activeRoutesMatch)) {
                el.active = true;
              } else {
                el.active = false;
              }
            }
          }
        });

        this.sidebar = Json_Sidebar;
      });
      // const userPermission = JSON.parse(
      //   localStorage.getItem("m7_dash_permissions")
      // );
    },
    getSideBar() {
      this.axios.get("side-bar-permissions").then((res) => {
        this.sidebar = res.data.data;
      });
    },
    getUserData() {
      this.axios
        .get("profile", {
          params: {
            internal: 1,
          },
        })
        .then((data) => {
          this.userDataExist = data.data.data;
        });
    },
    // havePermission(path) {
    //   let status;
    //   if (localStorage.getItem("Outfit_Dash_User_Type") != "superadmin") {
    //     if (localStorage.getItem("outfit_dash_permissions")) {
    //       let controls = JSON.parse(
    //         localStorage.getItem("outfit_dash_permissions")
    //       );
    //       const found = controls.find((control) => control == path);
    //       console.log(found?.url);
    //       if (found) {
    //         status = false;
    //       } else {
    //         status = true;
    //       }
    //     }
    //   } else {
    //     status = false;
    //   }
    //   return status;
    // },
    // getPermissions() {
    //   this.axios.get("get_my_permissions").then((res) => {
    //     localStorage.setItem(
    //       "outfit_dash_permissions",
    //       JSON.stringify(res.data.data)
    //     );
    //   });
    // },
  },

  computed: {
    ...mapGetters({
      current_theme: "theme_module/current_theme",
      lang: "lang_module/lang",
      user: "auth_module/currentUser",
    }),
  },

  async created() {
    this.control = this.$permission.setControls(this.$route.path);
    this.canEditPass = this.$permission.allowed("profile/update-password");
    this.canEditProfile = this.$permission.allowed("profile/edit");
    this.canShowProfile = this.$permission.allowed("profile/show");
    if (this.user.usertype == "superadmin") {
      this.manipulateTheSideBarComplete();
    } else {
      // this.getSideBar();
      // await this.getPermissions();
      this.manipulateTheSideBar();
    }
    if (!this.canShowProfile) {
      this.getUserData();
    }
  },
};
</script>

<style lang="scss"></style>
